import type { ReactNode } from "react";
import { CircularProgress } from "@mui/material";
import AiAssistantExpandableTree from "../../../AiAssistantExpandableTree/AiAssistantExpandableTree";
import type { ToolCallNodeProps } from "../../ToolCallIndicator.types";
import ToolCallIndicatorNode from "../ToolCallIndicatorNode/ToolCallIndicatorNode";

export type ToolCallIndicatorGroupKind = "sources" | "reasoning";

interface ToolCallIndicatorGroupProps {
  items: ToolCallNodeProps[];
  kind: ToolCallIndicatorGroupKind;
  defaultExpanded?: boolean;
  "data-test-id"?: string;
}

export default function ToolCallIndicatorGroup({
  items,
  kind,
  defaultExpanded,
  "data-test-id": testId,
}: ToolCallIndicatorGroupProps) {
  const hasPendingItems = items.some((item) => item.status === "pending");

  let title: ReactNode =
    kind === "sources" ? `Loaded Sources · ${items.length}` : "Reasoning";

  if (hasPendingItems) {
    title = (
      <div>
        <CircularProgress size={10} className="mr-1 leading-0" /> {title}
      </div>
    );
  }

  return (
    <AiAssistantExpandableTree
      title={title}
      defaultExpanded={defaultExpanded}
      framed
      data-test-id={testId}
    >
      {items.map((item) => (
        <AiAssistantExpandableTree.Item
          key={item.toolCallId}
          className="py-0! -my-0.5!"
          branchYOffset="1.3em"
        >
          <ToolCallIndicatorNode {...item} />
        </AiAssistantExpandableTree.Item>
      ))}
    </AiAssistantExpandableTree>
  );
}
